import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import merge from 'lodash/merge';
import chunk from 'lodash/chunk';
import qs from 'qs';
import Toolbar from '../Toolbar';
import BottomToolbar from '../BottomToolbar';
import List from '../List';
import BackButton from '../BackButton';
import Form from '../Form.js';
import { convertFacetsToFiltersArray, stringifyFacets } from '../../../utils/products.js';
import commify from '../../../modules/ajio-util/commify.js';
import { showModal, hideModal } from '../../../actions/modal.js';
import { removeFacets } from '../../../actions/shared/facets';
import Modal from '../Modal';
import hexCode from '../../../modules/ajio-util/hexCode.js';
import Button from '../Button.js';
import { setCurentFacetsQuery } from '../../../actions/shared/facets';
import { generateEvent } from '../../../utils/dataGrinch';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import properties from '../../../modules/ajio-util/properties';
import {
  getEnableFilterImprovement,
  getFilterImprovementConfig,
  getEnableFilterImprovementPhase2,
  getCountDisplayConfig
} from '../../../refresh/selectors/featureFlagsSelector';
import { getShowFacetCount } from '../../../modules/ajio-util/countDisplay';

class FacetCheckboxModalContentDesktop extends React.Component {
  constructor(props) {
    super(props);
    const { enableImprovedFacets = false, filterImprovementConfig = {} } = props; 
    this.state = {
      config: {
        brand: {
          showPopular: true,
          groupByAlphabets: true
        },
        ...(enableImprovedFacets && {
          genderfilter: {
            showPopular: true,  //change based on popularItems length if >0 = true else false
            popularItems: filterImprovementConfig?.gender?.genderFilterApparels || [
              'Women',
              'Men',
              'Girls',
              'Boys',
              'Infants',
              'Junior Girls',
              'Junior Boys'
            ],
            groupByAlphabets: false,
            secondaryHeader: filterImprovementConfig?.gender?.secondaryHeader?.toUpperCase() || "OTHERS",
            primaryHeader: filterImprovementConfig?.gender?.primaryHeader?.toUpperCase() || "GENDER",
          },
        }),
      }
    };
  }

  getFormDefaultValues() {
    const { facetsQuery } = this.props;
    return merge({}, facetsQuery);
  }

  groupEntityIdsByAlphabetic(facetEntityIds = []) {
    const { entities = {} } = this.props;
    const { selectedAlphabet } = this.state;
    if (selectedAlphabet) {
      facetEntityIds = facetEntityIds.filter((entityId = {}) => {
        const entity = entities[entityId] || {};
        const { name = '' } = entity;
        const charAtIndex0 = name.charAt(0);
        const isAlpha = charAtIndex0 && charAtIndex0.length === 1 && charAtIndex0.match(/[a-z]/i);
        if (selectedAlphabet == '#' && !isAlpha) {
          return true;
        } else {
          return name.toLowerCase().startsWith(selectedAlphabet);
        }
      });
    }
    const groupedItems = facetEntityIds.reduce(
      (acc, entityId) => {
        const entity = entities[entityId];
        const { code, count, name = '' } = entity;
        let charAtIndex0 = name.charAt(0);
        const isAlpha = charAtIndex0 && charAtIndex0.length === 1 && charAtIndex0.match(/[a-z]/i);
        charAtIndex0 = isAlpha ? charAtIndex0 : '#';
        if (acc.entities[charAtIndex0]) {
          acc.entities[charAtIndex0].push(entityId);
        } else {
          acc.entities[charAtIndex0] = [{ title: charAtIndex0 }, entityId];
          acc.results.push(charAtIndex0);
        }
        return acc;
      },
      { entities: {}, results: [] }
    );

    return groupedItems.results.reduce((acc, alp) => {
      if (groupedItems.entities[alp]) {
        acc = acc.concat(groupedItems.entities[alp]);
      }
      return acc;
    }, []);
  }

  getAllSelectedFacetEntityIds(facetEntityIds = [], formSelectedValues = {}, facetCode) {
    const facetSelectedValues = formSelectedValues[facetCode] || [];
    const { entities = {} } = this.props;
    return facetEntityIds.filter(entityId => {
      const entity = entities[entityId];
      const { code } = entity;
      return facetSelectedValues.includes(code);
    });
  }

  getAllPopularEntityIds(facetEntityIds = [], selectedEntityIds = []) {
    const { entities = {} } = this.props;
    return [...facetEntityIds]
      .sort((entityIdA, entityIdB) => {
        const entityA = entities[entityIdA] || {};
        const entityB = entities[entityIdB] || {};
        if (entityA.count > entityB.count) {
          return -1;
        } else if (entityA.count < entityB.count) {
          return 1;
        }
        return 0;
      })
      .slice(0, 5);
  }

  //FILTER_IMPROVEMENT
  getAllSuggestedEntityIds(facetEntityIds = [], selectedEntityIds = []) {
    const { entities = {} } = this.props;
    const filteredSuggestions = entities["brand"]?.suggestedValues?.filter(value => 
    facetEntityIds.includes(value)
    )
    return  filteredSuggestions || [];
  }

  formatChildrens(childrens = [], formSelectedValues = [], entities = {}, facetCode, searchTerm) {
    const config = this.state.config ? this.state.config[facetCode] || {} : {};
    const facetSelectedValues = formSelectedValues[facetCode] || [];

    // Handle colorGroups for verticalcolorfamily
    if (facetCode === 'verticalcolorfamily' && this.props.enableImprovedFacetsPhase2) {
      const parentEntity = entities[facetCode] || {};
      if (parentEntity.colorGroups && Array.isArray(parentEntity.colorGroups)) {
        const result = [];
        parentEntity.colorGroups.forEach(colorGroup => {
          if (colorGroup.values && Array.isArray(colorGroup.values)) {
            const groupColors = colorGroup.values
              .filter(colorValue => {
                if (searchTerm) {
                  return colorValue.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
                }
                return true;
              })
              .map(colorValue => {
                const colorKey = `${facetCode}-${colorValue.code}`;
                return colorKey;
              });

            if (groupColors.length > 0) {
              result.push({ title: colorGroup.name.toUpperCase() });
              result.push(...groupColors);
            }
          }
        });
        return result;
      }
    }

    // Handle l1Group for verticalsizegroupformat
    if (facetCode === 'verticalsizegroupformat' && this.props.enableImprovedFacetsPhase2) {
      const parentEntity = entities[facetCode] || {};
      if (parentEntity.l1Group && Array.isArray(parentEntity.l1Group)) {
        const l1Groups = parentEntity.l1Group;
        const shouldShowL1Heading = l1Groups.length > 1;
        const result = [];
        l1Groups.forEach(l1GroupItem => {
          if (l1GroupItem.l2Group && Array.isArray(l1GroupItem.l2Group)) {
            // Add L1 heading only if multiple L1 groups exist
            if (shouldShowL1Heading) {
              result.push({ title: l1GroupItem.name.toUpperCase(), isL1Heading: true });
            }

            l1GroupItem.l2Group.forEach(l2GroupItem => {
              if (l2GroupItem.values && Array.isArray(l2GroupItem.values)) {
                const groupSizes = l2GroupItem.values
                  .filter(sizeValue => {
                    if (searchTerm) {
                      return sizeValue.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
                    }
                    return true;
                  })
                  .map(sizeValue => {
                    const sizeKey = `${facetCode}-${sizeValue.code}`;
                    return sizeKey;
                  });

                if (groupSizes.length > 0) {
                  // Add L2 heading
                  result.push({ title: l2GroupItem.name.toUpperCase(), isL2Heading: true });
                  result.push(...groupSizes);
                }
              }
            });
          }
        });
        return result;
      }
    }

    let popularEntityIds = [];
    let popularSectionTitle = [];

    //FILTER-IMPROVEMENT--Gender
    let remainingEntityIds = [...childrens];
    const isGenderFacet = facetCode === 'genderfilter';
    if (isGenderFacet && this.props.enableImprovedFacets) {
      const popularItems = config.popularItems || [];
      if(popularItems.length > 0) { 
        popularEntityIds = childrens.filter(entityId => {
          const entity = entities[entityId] || {};
          const { name = '' } = entity;
          const compareTarget = name || entityId.replace('genderfilter-', '');
          return popularItems.some(item => item.toLowerCase() === compareTarget.toLowerCase());
        });
        remainingEntityIds = childrens.filter(id => !popularEntityIds.includes(id));
        const result = [];
        if (popularEntityIds.length > 0) {
          result.push({ title: config.primaryHeader}, ...popularEntityIds);
          if (remainingEntityIds.length > 0) {
            result.push({ title: config.secondaryHeader}, ...remainingEntityIds);
          }
        }
        return result;
      }
      return childrens;
    }

    if (config.showPopular && !searchTerm && childrens.length > 5) {
      //FILTER-IMPROVEMENT--Brand
      if(facetCode === 'brand' && this.props.enableImprovedFacets) {
        popularEntityIds = this.getAllSuggestedEntityIds(childrens) || [];
        if (popularEntityIds && popularEntityIds.length > 0) {
          popularSectionTitle.push({ title: this.props.filterImprovementConfig?.brand?.suggestedTitle?.toUpperCase() || 'SUGGESTED' });
        }
      } else{
        popularEntityIds = this.getAllPopularEntityIds(childrens);
        if (popularEntityIds && popularEntityIds.length > 0) {
          popularSectionTitle.push({ title: 'POPULAR' });
        }
      }
    }
    let fullEntityIds = childrens;
    if (config.groupByAlphabets) {
      fullEntityIds = this.groupEntityIdsByAlphabetic(childrens);
    }
    return [...popularSectionTitle, ...popularEntityIds, ...fullEntityIds];

  }

  setSeletedAlphabet(alp) {
    const { selectedAlphabet } = this.state;
    if (selectedAlphabet !== alp) {
      return this.setState({ selectedAlphabet: alp });
    }
    this.setState({ selectedAlphabet: undefined });
  }

  renderFilterByAlphabets(items = []) {
    const { entities = {}, newDesignLuxe } = this.props;
    const availableAlphabets = items.reduce((acc, entityId) => {
      const entity = entities[entityId] || {};
      const { name = '' } = entity;
      let charAtIndex0 = name.charAt(0).toLowerCase();
      const isAlpha = charAtIndex0 && charAtIndex0.length === 1 && charAtIndex0.match(/[a-z]/i);
      if (isAlpha && !acc.includes(charAtIndex0)) {
        acc.push(charAtIndex0);
      } else if (!isAlpha && !acc.includes('#')) {
        acc.push('#');
      }
      return acc;
    }, []);

    return (
      <div className="facet-filter-modal__search-alp-container">
        {newDesignLuxe ? (
          <span className="facet-checkbox-modal-input">
            <input
              type="text"
              placeholder="Search for brands"
              onChange={e => this.setSeletedAlphabet(e.target.value)}
            />
          </span>
        ) : (
          ''
        )}
      <ul style={{display:"inline"}} role="toolbar" aria-label='Brands'>
        {[
          '#',
          'a',
          'b',
          'c',
          'd',
          'e',
          'f',
          'g',
          'h',
          'i',
          'j',
          'k',
          'l',
          'm',
          'n',
          'o',
          'p',
          'q',
          'r',
          's',
          't',
          'u',
          'v',
          'w',
          'x',
          'y',
          'z'
        ].map((item, key) => {
          let selectedAlp = this.state.selectedAlphabet;
          let availableAlphabet = Array.isArray(availableAlphabets) && availableAlphabets.includes(item)
          return (
            <li
              id={`alphabet-tab-${item}`}
              role="button"
              type="button"
              aria-controls="alphabets-tabpanel"
              aria-pressed={selectedAlp === item}   // stays false if nothing is selected
              aria-disabled={!availableAlphabet}
              disabled={!availableAlphabet}
              className="rilrtl-button"
              key={key}
              onClick={() => {
                if (availableAlphabet) {
                  this.setSeletedAlphabet(item);
                }
              }}
              onKeyDown={(e) => {
                // if (!availableAlphabet) return;

                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  e.currentTarget.click();
                } else if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
                  e.preventDefault();
                  // const tabs = document.querySelectorAll('[role="tab"]');
                  const tabs = e.target.parentElement.querySelectorAll('[role="button"]')
                  const currentIndex = Array.from(tabs).indexOf(e.currentTarget);
                  const nextIndex =
                    e.key === "ArrowRight"
                      ? (currentIndex + 1) % tabs.length
                      : (currentIndex - 1 + tabs.length) % tabs.length;

                  (tabs[nextIndex]).focus();
                }
              }}
              tabIndex={
                !availableAlphabet
                  ? -1
                  : selectedAlp === item
                    ? 0
                    : selectedAlp
                      ? -1
                      : key === 0
                        ? 0   // first available if none selected
                        : -1
              }
              style={{ color: !availableAlphabet ? "#ebebeb" : "" }}
            >
              <div className={`item-selected ${selectedAlp == item ? 'active-alp' : ''}`} aria-label={`brands staring with ${item}`}>
                {item}
              </div>
              <div className={`ic-close ${selectedAlp == item ? 'active-alp' : ''}`} />
            </li>
          );
        })}
      </ul>
      </div>
    );
  }

  render() {
    const newDesignLuxe = this.props.newDesignLuxe;

    const {
      entities = {},
      pushToHistory,
      facetsQuery = {},
      location = {},
      history,
      fetchNextFacets,
      facetId,
      rightPaneFormValues,
      priceFacets = {},
      selectedFacets,
      enableImprovedFacets = false,
      enableImprovedFacetsPhase2 = false,
      showFacetCount = true
    } = this.props;
    const { selectedAlphabet } = this.state;
    const facetConfig = this.state.config ? this.state.config[facetId] || {} : {};
    const hasPriceFacet = !!facetsQuery.price;
    const parentEntity = entities[facetId] || {};
    const { name = '', childrens = [], code } = parentEntity;
    const allEntityIds = childrens.map(entityId => {
      const entity = entities[entityId] || {};
      return entity.code;
    });
    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreen;

    // Determine modal width: always use big width for color and size filters
    const isColorOrSizeFilter =
      code === 'verticalcolorfamily' || code === 'verticalsizegroupformat';
    let modalWidthClass = 'width-1024';
    if (!isColorOrSizeFilter) {
      if (!facetConfig.groupByAlphabets && childrens.length <= 24) {
        modalWidthClass = 'width-512';
      }
    }

    return (
      <Modal
        ariaLabel={`Choose ${name}`}
        name="facet-filter-modal"
        className={`
          facet-filter-modal facet-filter-modal-next 
          ${modalWidthClass}
          
          ${code === 'verticalcolorfamily' && childrens.length < 19 ? 'color-filter-layout' : ''}
          ${code === 'verticalcolorfamily' ? 'color-filter-modal' : ''}
        `}
      >
        <Form
          defaultValues={this.getFormDefaultValues()}
          onSubmit={formValues => {
            this.props.setCurentFacetsQuery(formValues);
            this.setState({ selectedAlphabet: '' });
            if (newDesignLuxe) {
              gtmEventPush({
                event: 'plp_filter_apply',
                event_category: 'product list interactions',
                event_action: 'filter applied',
                event_label: Object.values(formValues).toString(),
                no_of_filters: Object.keys(formValues).length,
                store_type: 'luxe',
                screen_name: screenName,
                screen_type: screenType
              });

              segmentEventPush({
                event: 'Plp Filter Applied',
                event_category: 'product list interactions',
                event_action: 'filter applied',
                event_label: Object.values(formValues).toString(),
                no_of_filters: Object.keys(formValues).length,                
                l1_filter : Object.values(formValues).toString(),
                store_type: 'luxe',
                screen_name: screenName,
                screen_type: screenType,
                ...(convertFacetsToFiltersArray(formValues).length > 0 && {
                  filters: convertFacetsToFiltersArray(formValues)
                })
              })

            } else {
              generateEvent({
                Event: 'Filter',
                value: {
                  'ListOfFilters:': qs.stringify(formValues)
                }
              });

              segmentEventPush({
                event: 'Plp Filter Applied',
                event_category: 'product list interactions',
                event_action: 'filter applied',
                event_label: Object.values(formValues).toString(),
                no_of_filters: Object.keys(formValues).length,                
                l1_filter : Object.values(formValues).toString(),
                store_type: 'ajio',
                screen_name: screenName,
                screen_type: screenType,
                ...(convertFacetsToFiltersArray(formValues).length > 0 && {
                  filters: convertFacetsToFiltersArray(formValues)
                })
              })
              
            }
            pushToHistory({
              facets: stringifyFacets(formValues),
              currentPage: 0
            });
            this.props.hideModal('facet-filter-modal');
          }}
        >
          {({ getFormDefaultProps, getFormValue, isTouched, addFormValue, formValues }) => {
            let formValue = getFormValue(code);
            let priceRange = getFormValue('price') || [];
            let priceRangeSplits = priceRange[0] ? priceRange[0].split(',') : [];
            let searchTerm = getFormValue('searchTerm');
            // For colorGroups and l1Group, filtering is handled in formatChildrens
            let filteredChildrens = (code === 'verticalcolorfamily' && enableImprovedFacetsPhase2 && entities[code]?.colorGroups) || (code === 'verticalsizegroupformat' && enableImprovedFacetsPhase2 && entities[code]?.l1Group)
              ? childrens 
              : filterChildrenByName(searchTerm, childrens, entities);
            filteredChildrens = this.formatChildrens(
              filteredChildrens,
              this.getFormDefaultValues(),
              entities,
              code,
              searchTerm
            );
            const chunkRange = newDesignLuxe ? 9 : code === 'verticalcolorfamily' ? 11 : 12;
            let isGenderFilter = code === 'genderfilter';
            let customFirstColumnSizeForGender = null;
            if (isGenderFilter && enableImprovedFacets && facetConfig.popularItems?.length > 0) {
              customFirstColumnSizeForGender = facetConfig.popularItems.length + 1;
            }
            let finalChunks = [];
            // l1Group: Each L1 group (with all its L2 groups and children) in its own column
            if (
              code === 'verticalsizegroupformat' &&
              enableImprovedFacetsPhase2 &&
              entities[code]?.l1Group
            ) {
              let currentL1Group = [];
              filteredChildrens.forEach(item => {
                if (typeof item === 'object' && item.title && item.isL1Heading) {
                  // L1 heading - start a new column
                  if (currentL1Group.length > 0) {
                    finalChunks.push([currentL1Group]);
                  }
                  currentL1Group = [item];
                } else {
                  currentL1Group.push(item);
                }
              });
              if (currentL1Group.length > 0) {
                finalChunks.push([currentL1Group]);
              }
            }
            // Default chunking logic for other filters
            else {
              const filteredChildrensChunks = chunk(filteredChildrens, chunkRange);
              let listDistribution = [];
              filteredChildrensChunks.forEach(item => {
                item.forEach(tempItem => {
                  if (typeof tempItem === 'object' && tempItem.title) {
                    listDistribution.push([tempItem]);
                  } else {
                    const lastGroup = listDistribution[listDistribution.length - 1];
                    if (lastGroup) {
                      lastGroup.push(tempItem);
                    } else {
                      listDistribution.push([tempItem]);
                    }
                  }
                })
              });
              if (customFirstColumnSizeForGender !== null) { //FILTER-IMPROVEMENT-for variable column length for gender filter as it will be controlled by amplitude
                let itemCount = 0;
                let currentChunk = [];
                let isFirstColumn = true;
                
                listDistribution.forEach((item, index) => {
                  const itemLength = item.length;
                  const maxSize = isFirstColumn ? customFirstColumnSizeForGender : chunkRange;
                  
                  if (itemCount + itemLength <= maxSize) {
                    currentChunk.push(item);
                    itemCount += itemLength;
                  } else {
                    if (currentChunk.length > 0) {
                      finalChunks.push(currentChunk);
                      isFirstColumn = false;
                    }
                    currentChunk = [item];
                    itemCount = itemLength;
                  }
                  });
                  if (currentChunk.length > 0) {
                    finalChunks.push(currentChunk);
                  }
              } else {
                listDistribution.forEach(item => {
                  let count = 0;
                  if (!finalChunks.length) {
                    finalChunks.push([item])
                    return
                  }

                  for (let i = 0; i < finalChunks[finalChunks.length - 1].length; i++) {
                    count += finalChunks[finalChunks.length - 1][i].length;
                  }
                  if (count + item.length <= chunkRange) {
                    finalChunks[finalChunks.length - 1].push(item);
                  } else {
                    finalChunks.push([item])
                  }
                })
              }
            }
             const imageBaseUrl = `${properties.getProperty('imageBaseUrl')}`;
            return (
              <div className="more-popup-container">
                <div className="facet-filter-modal__header">
                  <div className="facet-filter-modal__title" aria-label={`Choose ${name}`} role='heading' aria-level={2}>
                    {/* Choose <span>{name}</span> */}
                      {name?.toLowerCase() === 'gender' && enableImprovedFacets ? (
                        <>{this.props.filterImprovementConfig?.gender?.title || "Shop For"}</>
                      ) : (
                        <>Choose <span>{name}</span></>
                      )}
                  </div>
                  {facetConfig.groupByAlphabets ? this.renderFilterByAlphabets(childrens) : null}
                </div>
                <div className="facet-filter-modal__body" id="alphabets-tabpanel">
                  {finalChunks.map((filteredChildrensChunk, key) => {
                    return (
                      <div className={`column column-${finalChunks.length}`}>
                        {
                          filteredChildrensChunk.map((eItem, key) => {
                            return (
                              <List
                                key={`modal-${key}`}
                                numOfItems={eItem.length}
                                listItemRenderer={listProps => {
                                  const { index } = listProps;
                                  const entityId = eItem[index];
                                  if (typeof entityId === 'object') {
                                    const isL1Heading = entityId.isL1Heading;
                                    const isL2Heading = entityId.isL2Heading;
                                    return (
                                      <div role="heading" aria-level={3} aria-roledescription='List Heading'>
                                        <div 
                                          className={`facet-filter-modal__item facet-linkhead facet-filter-modal__item-title ${
                                            isL2Heading ? 'facet-size-l2-heading' : ''
                                          }`}
                                        >
                                          {entityId.title}
                                        </div>
                                      </div>
                                    );
                                  }
                                  const entity = entities[`${entityId}`] || {};
                                  let isChecked = false;
                                  if (formValue) {
                                    isChecked = formValue.includes(entity.code);
                                  }
                                  const inputId = `modal-${entity.name}-${entityId}-${index}`;
                                  // let entity = entities[`${entityId}`] || {};
                                  // if (code === "verticalsizegroupformat") {
                                  //   entity = {
                                  //     ...entity,
                                  //     code: entityId   // use full unique key
                                  //   };
                                  // }
                                  // let isChecked = false;
                                  // if (formValue) {
                                  //   isChecked = formValue.includes(entity.code);
                                  // }
                                  return (
                                    <div className="facet-filter-modal__item facet-linkhead">
                                      
                                        <input
                                          {...getFormDefaultProps({
                                            type: 'checkbox',
                                            name: code,
                                            value: entity.code
                                          })}
                                          id={inputId}
                                          checked={isChecked}
                                        />
                                      <label
                                        className={`${code == 'verticalcolorfamily'
                                            ? `facet-color facet-color-${entity.name} facet-color-${code}`
                                            : ''
                                          } ${isChecked ? 'facet-checked' : 'facet-unchecked'}`}
                                        htmlFor={inputId}
                                        // tabIndex={0}
                                      >
                                        {code === 'verticalcolorfamily' ? (
                                          <i className="facet-checkbox-color facet-checkbox-color-outer">
                                            <i
                                              className="facet-checkbox-color facet-checkbox-color-inner"
                                              style={{
                                                backgroundColor:
                                                  hexCode(entity.name.toLowerCase()) || entity.name,
                                                  ...(entity.name === 'Multi' ? { background : `url(${`${imageBaseUrl}/static/img/multi_color_swatch.png`})`, backgroundRepeat: "no-repeat", backgroundPosition: "center"} : {})
                                              }}
                                            />
                                          </i>
                                        ) : null}

                                        <span
                                          className={`rilrtl-list-item__title popup-facet-name ${isChecked ? 'list-active' : ''
                                            }`}
                                        >
                                          <span className="facet-list-title-name" {...name.toLowerCase() === 'discount' && {'aria-label': `${entity.name} off`}}>{`${entity.name}`} </span>
                                          {showFacetCount && (
                                          <span className="facet-list-title-count" aria-label={`with ${commify(entity.count || '')} items`}>
                                            {' '}
                                            {`(${commify(entity.count || '')})`}
                                          </span>
                                          )}
                                        </span>
                                      </label>
                                    </div>
                                  );
                                }}
                                // avoidFirstLITag={true}
                                keepDefaultRole={true}
                                // treatFirstItemAsHeadingAndIgnoreListBehavior={true}
                              />
                            );
                          })
                        }
                      </div>
                    )
                  })}
                </div>
                <div className="facet-filter-modal__footer">
                  <div className="facet-filter-modal__form-actions">
                    <Button
                      className="select-all"
                      modifier={['filter-footer-action']}
                      type="button"
                      onClick={e => {
                        addFormValue(parentEntity.code, allEntityIds);
                        e.stopPropagation();
                        // Update live region for screen reader
                        const announcer = document.getElementById("checkbox-status-announcer");
                        if (announcer) {
                          announcer.textContent = "";
                          setTimeout(() => {
                            announcer.textContent = "All checkboxes are checked";
                          }, 100);
                        }
                      }}
                      aria-label="Select All">
                      Select All
                    </Button>
                    <Button
                      className="select-all"
                      modifier={['filter-footer-action', 'select-all']}
                      type="button"
                      onClick={e => {
                        addFormValue(parentEntity.code, []);
                        e.stopPropagation();
                        const announcer = document.getElementById("checkbox-status-announcer");
                        if (announcer) {
                          announcer.textContent = "";
                          setTimeout(() => {
                            announcer.textContent = "All checkboxes are unchecked";
                          }, 100);
                        }
                      }}
                      aria-label="Select All">
                      Clear All
                    </Button>
                    <Button
                      type="submit"
                      className="apply-popup-button"
                      modifier={['filter-footer-action', 'apply']}
                      aria-label="Apply">
                      Apply
                    </Button>
                  </div>
                </div>
                <div
                  id="checkbox-status-announcer"
                  aria-live="assertive"
                  aria-atomic="true"
                  className="sr-only"
                // style={{ position: 'absolute', left: '-9999px', height: '1px', width: '1px', overflow: 'hidden' }}
                />
              </div>
            );
          }}
        </Form>
      </Modal>
    );
  }
}

function filterChildrenByName(searchString = '', childrens = '', entities) {
  if (!searchString) return childrens;
  if (!Array.isArray(searchString)) {
    searchString = searchString.toLowerCase();
  }
  return childrens.filter(entityId => {
    const entity = entities[entityId] || {};
    let { name = '' } = entity;
    name = name.toLowerCase();
    if (Array.isArray(searchString)) {
      return searchString.includes(name.charAt(0));
    }
    return name.startsWith(searchString);
  });
}

function mapStateToProps(state) {
  const { facets = {}, modals = {}, flags } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const modal = modals['facet-filter-modal'] || {};
  const facetId = modal.state ? modal.state.facetId : null;
  const { currentFacets = {}, nextFacets = {}, priceFacets = {}, plpGender = "" } = facets;
  const { groupResults = [], groupEntities = {}, entities = {} } = currentFacets;
  const { query: facetsQuery } = currentFacets;
  const countConfig = getCountDisplayConfig(state);
  const showFacetCount = getShowFacetCount(countConfig, storeName);
  return {
    newDesignLuxe,
    showFacetCount,
    groupResults,
    groupEntities,
    entities,
    facetsQuery,
    priceFacets,
    facetId,
    enableImprovedFacets: getEnableFilterImprovement(state) || false,
    enableImprovedFacetsPhase2: getEnableFilterImprovementPhase2(state) || false,
    filterImprovementConfig: getFilterImprovementConfig(state) || {},
    plpGender
  };
}
function mapDispatchToProps(dispatch, ownProps) {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    removeFacets: id => {
      dispatch(removeFacets(id));
    },
    setCurentFacetsQuery: query => {
      dispatch(setCurentFacetsQuery(query));
    }
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FacetCheckboxModalContentDesktop)
);
